@if ($addToCartState(); as state) {
  <div class="add-to-cart__container" [@modalEnterAnimation]>
    <div class="add-to-cart__content">
      <boels-dialog-header
        [label]="state.labels().header | transloco"
        (close)="closeModal()"
      ></boels-dialog-header>

      <boels-order-entry
        [orderEntry]="state.mainEntry()"
        [accessories]="state.accessoriesEntries()"
        [autoFocusTarget]="autoFocusTarget()"
        (mainQuantityChanged)="recalculateMandatoryAccessoryQuantities()"
        (deleteOrderEntry)="deleteOrderEntry($event)"
        variant="edit"
      ></boels-order-entry>

      <boels-product-price-disclaimer
        [$product]="state.mainEntry().product!"
      ></boels-product-price-disclaimer>
    </div>
    <div class="add-to-cart__footer">
      <button
        boelsButton
        [isDisabled]="$loading()"
        (click)="addToCart()"
        [isLoading]="$loading()"
        variant="main"
        shape="pill"
      >
        {{ state.labels().submitBtn | transloco }}
      </button>
    </div>
  </div>
}
